import { HTTP_METHODS } from '@app/configs/api';
import { ACCOUNT_ENDPOINTS } from '@app/configs/api/account';
import { baseApi } from './baseApi';
export const additionalBorrowerInfoApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        submitAdditionalBorrowerInfo: builder.mutation({
            query: (data) => ({
                url: ACCOUNT_ENDPOINTS.userProfile,
                method: HTTP_METHODS.PUT,
                body: data,
            }),
        }),
    }),
    overrideExisting: false,
});
export const { useSubmitAdditionalBorrowerInfoMutation } = additionalBorrowerInfoApi;
